<template>
  <div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full">
        <label>Empregador:</label>

        <vx-input-group class="mb-2">
          <vs-input class="required" disabled :value="companyName" />

          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button
                color="primary"
                type="border"
                icon="search"
                title="Buscar"
                @click="showEmployerSearchGrid = true"
              ></vs-button>
              <vs-button
                color="primary"
                type="border"
                icon="add"
                title="Incluir"
                @click="openEmployerCreateForm()"
              ></vs-button>
              <vs-button
                color="primary"
                type="border"
                icon="clear"
                title="Limpar"
                @click="occupation.employer = null"
              ></vs-button>
            </div>
          </template>
        </vx-input-group>

        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('employer_id')"
        >{{ errors.first('employer_id') }}</span> -->
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-input
          type="text"
          class="w-full required"
          label="Profissão"
          v-model="occupation.name"
          v-validate="'required'"
        />
        <!-- <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span> -->
      </div>

      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-input
          type="text"
          class="w-full"
          label="Tempo Profissão (anos)"
          v-model="occupation.occupation_time"
          v-mask="['####']"
        />
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('occupation_time')"
        >{{ errors.first('occupation_time') }}</span> -->
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-input
          class="w-full input-text-align-right"
          label="Renda Bruta"
          ref="gross_income"
          v-model.lazy="occupation.gross_income"
          v-money="money"
        />
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('gross_income')"
        >{{ errors.first('gross_income') }}</span> -->
      </div>

      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-input
          class="w-full input-text-align-right"
          label="Valor Patrimonial"
          ref="equity_value"
          v-model="occupation.equity_value"
          v-money="money"
        />
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('equity_value')"
        >{{ errors.first('equity_value') }}</span> -->
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          class="mt-5 float-right"
          type="border"
          @click="save"
          :disabled="!validateForm"
        >Salvar</vs-button>
      </div>
    </div>

    <vs-popup title="Empregador" :active.sync="showEmployerSearchGrid">
      <Grid
        :service="services.legalEntityService"
        route_name="legal_entities"
        hide_actions="true"
        :delegate="employerSelected"
      ></Grid>
    </vs-popup>

    <vs-popup
      fullscreen
      title="Cadastrar Empregador / Pessoa Jurídica"
      :active.sync="showEmployerCreateForm"
    >
      <LegalEntityForm :services="services" :legalEntityId="null" :simpleCreation="true" />
    </vs-popup>
  </div>
</template>

<script>
import { VMoney } from 'v-money'
import LegalEntityForm from '../tabs/LegalEntityForm'

export default {
  components: {
    LegalEntityForm
  },
  directives: { money: VMoney },
  props: {
    services: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    id: null,
    parentEntity: null,
    occupation: {
      id: null,
      name: null,
      occupation_time: null,
      gross_income: null,
      equity_value: null,
      employer: null
    },
    showEmployerSearchGrid: false,
    showEmployerCreateForm: false,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    }
  }),
  computed: {
    validateForm() {
      return this.occupation.employer !== null && this.occupation.name
    },
    companyName() {
      return this.occupation.employer
        ? this.occupation.employer.company_name
        : ''
    }
  },
  watch: {},
  methods: {
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const params = {
        id: this.occupation.id,
        name: this.occupation.name,
        occupation_time: this.occupation.occupation_time,
        gross_income: this.occupation.gross_income,
        equity_value: this.occupation.equity_value,
        natural_entity_id: this.parentEntity.id,
        employer_id: this.occupation.employer
          ? this.occupation.employer.id
          : null
      }

      this.services.occupationService.createOrUpdate(params).then(
        data => {
          this.$vs.loading.close()
          this.occupation.id = data.id
          this.notifySuccess(this.$vs)
        },
        error => {
          this.$vs.loading.close()
          this.showErrors(this.$validator, error)
        }
      )
    },
    openEmployerCreateForm() {
      this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', null)
      this.showEmployerCreateForm = true
    },
    employerSelected(employer) {
      this.occupation.employer = employer
      this.showEmployerSearchGrid = false
    }
  },
  created() {
    const onEscape = e => {
      if (e.keyCode === 27) {
        this.showEmployerSearchGrid = false
      }
    }
    document.addEventListener('keydown', onEscape)
  },
  beforeMount() {},
  mounted() {
    this.$root.$on('legalEntityClosed', () => {
      this.showEmployerCreateForm = false
    })

    this.$root.$on('legalEntityCreated', legalEntity => {
      this.showEmployerCreateForm = false
      this.occupation.employer = legalEntity
    })

    this.$root.$on('naturalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['naturalEntity/naturalEntity']
      if (this.parentEntity.occupation) {
        this.occupation.id = this.parentEntity.occupation.id
        this.occupation.name = this.parentEntity.occupation.name
        this.occupation.occupation_time = this.parentEntity.occupation.occupation_time
        this.occupation.employer = this.parentEntity.occupation.employer

        // Workaround to fix Vuetify input with v-money directive
        this.$refs.gross_income.$el.getElementsByTagName(
          'input'
        )[0].value = this.parentEntity.occupation.gross_income
        this.$refs.equity_value.$el.getElementsByTagName(
          'input'
        )[0].value = this.parentEntity.occupation.equity_value
      }
    })

    // this.$root.$on('legalEntityUpdated', () => {
    //   this.parentEntity = this.$store.getters['legalEntity/legalEntity']
    // })
  }
}
</script>